import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { throwError } from 'rxjs';

export function handleError(error: HttpErrorResponse) {
  // Verificar si el entorno es de navegador
  if (typeof window !== 'undefined' && error.error instanceof ErrorEvent) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error.message);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    console.error(
      `Backend returned code ${error.status}, ` +
      `body was: ${error.error}`);
  }
  // return an observable with a user-facing error message
  return throwError(() => new Error('Something bad happened; please try again later.'));
}

export function fechaYymmdd(date: Date) {
  const modifiedDate = new Date(date).toISOString().slice(0, 10);
  return `${modifiedDate.split('-')[0]}/${modifiedDate.split('-')[1]}/${modifiedDate.split('-')[2]}`;
}

export function ConfirmedValidator(controlName: string, matchingControlName: string){
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
